
<div class="lg:relative z-0 lg:flex lg:flex-col flex-1 lg:overflow-hidden h-full overflow-y-auto">
  <div class="p-2 flex justify-between gap-3  items-center mb-2  bg-white dark:bg-zinc-950 rounded-lg ring-1 ring-zinc-200 dark:ring-white/5">
    <div class="flex flex-wrap gap-2">
      <div class="flex  gap-2 flex-wrap"  *ngIf="drivers?.length">
        <div>
          <div class="relative min-w-48">
            <input [(ngModel)]="search" type="text" placeholder="Search" class="pl-8" />
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              stroke="currentColor" class="absolute left-2 top-1/2 transform -translate-y-1/2 size-5">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
            </svg>
          </div>
        </div>
        <div>
          <div class="min-w-48">
            <ng-select id="los" [(ngModel)]="selectedCompany" (change)="onSelectCompany($event)" [clearable]="false">
              <ng-option value="">Select Company</ng-option>
              <ng-option *ngFor="let company of companies" value="{{ company.id }}">{{
                company.name | titlecase }}</ng-option>
            </ng-select>
          </div>
        </div>
        <div
        class="w-8 h-8 rounded-full flex items-center justify-center bg-zinc-950/5 dark:btn-secondary ">
        <!-- <span class="text-sm"> {{drivers?.length}} -->
        <span class="text-sm">{{(drivers | filter:search)?.length }}</span>
      </div>
      </div>
    </div>
    <div *ngIf="type"
      class="inline-flex self-end flex-wrap p-1 rounded-lg gap-0.5 bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg focus:outline-none">
  
      <button class="w-full md:w-auto" type="button" (click)="getPoints('start')"
        [ngClass]="{
                                              'cursor-pointer btn btn-secondary sm:text-xs/5': type === 'start',
                                              'cursor-pointer btn-outline dark:hover:bg-zinc-700/20 border-transparent btn-outline-secondary sm:text-xs/5 ng-star-inserted':type === 'gps'}"
        >
        Starting Point
      </button>
      <button class="w-full md:w-auto" type="button" (click)="getPoints('gps')"
        [ngClass]="{
                                              'cursor-pointer btn btn-secondary sm:text-xs/5': type === 'gps',
                                              'cursor-pointer btn-outline dark:hover:bg-zinc-700/20 border-transparent btn-outline-secondary sm:text-xs/5 ng-star-inserted':type === 'start'}"
        >
        GPS Point
      </button>
    </div>
  
  </div>
  <div class="lg:flex-1 lg:flex h-full min-h-0 gap-2">
    <!-- Drivers -->
    <div class="lg:w-80 flex-shrink-0 xl:order-first flex flex-col lg:h-full overflow-hidden bg-white dark:bg-zinc-950 rounded-lg ring-1 ring-zinc-200 dark:ring-white/5 gap-y-2">
   
        <!-- Tabs -->
       
    

        <!-- Drivers -->
        <ul class="p-2 overflow-y-auto h-96 lg:h-full flex flex-col space-y-2">
          <!-- border-zinc-950/10 dark:border-white/10 -->
          <li *ngFor="let driver of filteredDrivers | filter : search; let index = index" (click)="onSelectDriver(driver)"
            class="cursor-pointer flex items-center gap-4 p-2 rounded-lg ring-1 ring-zinc-200 dark:ring-white/5 text-sm-dark dark:btn-secondary" [ngClass]="{
                'bg-zinc-300 dark:bg-zinc-700 text-zinc-900 dark:text-white dark:border-zinc-600': driver.id === selectedDriver?.id,
                'bg-zinc-950/5 dark:bg-white/5': driver.id !== selectedDriver?.id
              }">
            <!-- <span class="text-sm-dark">Driver</span> -->
            <div class="flex flex-1 items-center gap-2">
              <div class="h-10 w-10 flex-shrink-0">
                <img class="h-10 w-10 border border-gray-200 rounded-full object-cover" alt=""
                  src="{{driver.profileImageURL || 'assets/images/profileImagePlaceholder.png'}}" />
              </div>
              <div class="w-full">
                <div class="flex justify-between items-center">
                  <div class="font-medium text-main-dark">{{(driver.displayName) | titlecase}}</div>
                  <div class="font-bold text-main-dark text-xs">D{{index + 1}}</div>
                </div>
                <div class="text-main-light">{{driver.email}}</div>
                <div class="text-primary text-xs font-semibold" *ngIf="preCompanies && driver.company && preCompanies[driver.company]">{{preCompanies[driver.company].name}}</div>
              </div>
            </div>
          </li>
        </ul>
    </div>

    <!-- Map -->
    <div
      class="relative z-0 h-96 lg:h-full lg:flex-1 overflow-y-auto focus:outline-none xl:order-last p-2 rounded-lg bg-white dark:bg-zinc-950 ring-1 ring-zinc-200 dark:ring-white/5">
      <google-map #googleMap height="100%" width="100%" [center]="center" [zoom]="zoom">
      </google-map>
    </div>
  </div>
</div>